import { render } from "./ListeArticles.vue?vue&type=template&id=da04be8a&scoped=true"
import script from "./ListeArticles.vue?vue&type=script&lang=js"
export * from "./ListeArticles.vue?vue&type=script&lang=js"

import "./ListeArticles.vue?vue&type=style&index=0&id=da04be8a&lang=scss&scoped=true"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da04be8a"]])

export default __exports__